import {
  AudioPopupDefinition,
  AUDIO_POPUP,
  ImageMapDefinition,
  IMAGE_MAP
} from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';
import { t } from 'ttag';

export const Interactive23: Translator = sequence => {
  return translate(sequence, item => {
    if (item.__typename === 'ImageMap') {
      let maxWidth = 1200;
      let maxHeight = 800;

      if (
        item.pictures &&
        item.pictures.length &&
        item.pictures?.[0]?.mediaUrl
      ) {
        //get dimensions of image
        const img = new Image();
        img.onload = function () {
          if (img.width && img.height) {
            maxWidth = img.width;
            maxHeight = img.height;
          }
        };
        img.src = item.pictures?.[0]?.mediaUrl;
      }

      return {
        type: IMAGE_MAP,
        id: item.id,
        values: {
          imageUrl: item.pictures?.[0]?.mediaUrl,
          body: t`Click the icons to continue.`
        },
        items: (item.items || []).map((i, index) => {
          const parts = (i.coordinates || '').split(',');
          return {
            type: AUDIO_POPUP,
            id: `${item.id}-${index}`,
            items: [],
            values: {
              title: item.variant == 'number' ? index + 1 : null,
              left: parts[0] && (parseInt(parts[0]) * 100) / maxWidth,
              top: parts[1] && (parseInt(parts[1]) * 100) / maxHeight,
              name: i.title,
              body: i.body,
              mediaUrl: i.audios?.[0]?.mediaUrl,
              subtitlesUrl: i.audios?.[0]?.subtitlesUrl,
              blocking: true,
              replay: true,
              isPopupCentered: true,
              scroll: true
            }
          } as AudioPopupDefinition;
        })
      } as ImageMapDefinition;
    }
    return null;
  });
};
